import PropTypes from 'prop-types'
import React from 'react'
import { default as ReactSelect } from 'react-select'

const Select = (props) => {
  if (props.allowSelectAll) {
    return (
      <ReactSelect
        {...props}
        options={[props.allOption, ...props.options]}
        onChange={(selected) => {
          if (
            selected !== null &&
            selected.length > 0 &&
            selected[selected.length - 1].value === props.allOption.value
          ) {
            return props.onChange(props.options)
          }
          return props.onChange(selected)
        }}
        value={props.options.filter(
          (option) => option.label === props.selectedValue
        )}
        isSearchable={false}
      />
    )
  }

  return <ReactSelect {...props} isSearchable={false} />
}

Select.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowSelectAll: PropTypes.bool,
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
}

Select.defaultProps = {
  allOption: {
    label: 'Select all',
    value: '*',
  },
}

export default Select
